<div *ngIf="!hasSelectedMaintenanceType">
  <input
    class="input-legacy"
    type="text"
    [placeholder]="'MAINTENANCES.TYPES_SEARCH_PLACEHOLDER' | translate"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedMaintenanceType()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let maintenanceType of maintenancesTypes" [value]="maintenanceType.id">
      {{ maintenanceType.name }}
    </mat-option>
    <mat-option *ngIf="!maintenancesTypes.length">
      {{ 'MAINTENANCES.TYPES_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedMaintenanceType">
  <input class="input-legacy" disabled type="text" [value]="selectedMaintenanceType.name" />

  <button
    mat-icon-button
    class="cancel-button accent-700-fg"
    *ngIf="hasSelectedMaintenanceType"
    (click)="deselectMaintenanceType()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</div>
